import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, SiteTypeService, BurnListService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin, Camera, BurnListRegion } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute, Router } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { MapComponent } from 'src/app/components/map/map.component';

//import * as L from 'leaflet';
import 'leaflet';
import 'leaflet-semicircle';
//import semiCircle from 'leaflet-semicircle';
import { isNumber } from 'highcharts';
import { FireCameraViewer } from 'src/app/components/fire-camera-viewer/fire-camera-viewer.component';

declare let L;
// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class FireForesightMenuComponent implements OnInit, OnDestroy {
  
  public list : StatusType[];
    
  public isNavigationOpen;
  public cameras : Camera[];
  public statusTypes : StatusType[];
  public incidents : Incident[];
  public siteId: any;
  public siteIdFilter: any;
  public incidentId: any;
  public view: string;
  public burnListRegions: BurnListRegion[] = [];
  public burnListRegionsLoading: boolean = false;
  
  constructor(
    public app: ApplicationConfigService, 
    public security: AzureAuthService,
    public fire: FireService,
    private burnListService: BurnListService,
    private route: ActivatedRoute,
    private router: Router) { 
      router.events.subscribe(val => {
        const route: any = val;
        if (route.url){
          //console.log(route.url);
          const parts = route.url.split('/');
          if (parts.length > 2 && parts[2] != null){
            this.view = parts[2].toLowerCase();
            if (this.view.startsWith("camera") || this.view.startsWith("landscape")) {
              if (parts.length > 3){
                const uri = parts[3];
                this.siteId = Number(uri);
              }
            } else if (this.view.startsWith("incident")) {
              if (parts.length > 3){
                const uri = parts[3];
                this.incidentId = Number(uri);
              }
            }
          }
        }      
      });
      
      app.customerChanged$.subscribe(cid => {
        fire.get(true);
        this.loadBurnListRegions();
      });
      
  }

  ngOnInit(): void {    
    this.fire.get(false);
    this.fire.watch();
    this.loadBurnListRegions();
  }

  ngOnDestroy(): void {
    this.fire.stopWatch();
  }

  loadBurnListRegions(): void {
    this.burnListRegionsLoading = true;
    this.burnListService.BurnListGetBurnListRegions().subscribe(
      (regions) => {
        this.burnListRegions = regions || [];
        this.burnListRegionsLoading = false;
      },
      (error) => {
        console.error('Error loading burn list regions:', error);
        this.burnListRegions = [];
        this.burnListRegionsLoading = false;
      }
    );
  }

  getBackgroundColour(incident: Incident){
    if (incident.responsiblePartyId == null){
      return "";
    }
    const rp = this.fire.responsibleParties.find(r => r.responsiblePartyId == incident.responsiblePartyId);
    return rp.colour;
  }
  
  isUnconfirmedIncident(incident: Incident): boolean {
    return incident.status && incident.status.displayName && 
           incident.status.displayName.toLowerCase().includes('unconfirmed');
  }
  
  // Check if a status has any incidents
  hasIncidentsForStatus(statusId: number): boolean {
    if (!this.fire.incidents || this.fire.incidents.length === 0) {
      return false;
    }
    return this.fire.incidents.some(incident => 
      incident.status.statusId === statusId && 
      (this.siteIdFilter == 0 || this.siteIdFilter == null || incident.site.siteId == this.siteIdFilter)
    );
  }
  
  // Check if there are any active detections at all
  hasAnyActiveDetections(): boolean {
    if (!this.fire.incidents || this.fire.incidents.length === 0) {
      return false;
    }
    if (this.siteIdFilter == 0 || this.siteIdFilter == null) {
      return this.fire.incidents.length > 0;
    }
    return this.fire.incidents.some(incident => incident.site.siteId == this.siteIdFilter);
  }
  
  toggleSidebar(){
    console.log('toggle menu');
    this.isNavigationOpen = false;
    this.app.menuOpen = false;
  }
}